import { createAnalyticsHandlers } from "@/mocks/handlers/analytics";
import { createAuthHandlers } from "@/mocks/handlers/auth";
import { createCareplanHandlers } from "@/mocks/handlers/careplan";
import { createMessageHandlers } from "@/mocks/handlers/messages";
import { createPostPurchaseHandlers } from "@/mocks/handlers/post-purchase";
import { createProductHandlers } from "@/mocks/handlers/products";
import { createProfileHandlers } from "@/mocks/handlers/profile";
import { createProfilingHandlers } from "@/mocks/handlers/profiling";
import { createProgressHandlers } from "@/mocks/handlers/progress";
import { createShopifyHandlers } from "@/mocks/handlers/shopify";
import { createSubscriptionHandlers } from "@/mocks/handlers/subscriptions";
import { createSurveyHandlers } from "@/mocks/handlers/surveys";
import { createUnhandledHandlers } from "@/mocks/handlers/unhandled";
import { getStorefrontEndpoint, getStorefrontOrigin } from "@/mocks/storefront-urls";

export type MockHandlerOptions = {
  apiUrl: string;
  shopifyDomain: string;
  shopifyApiVersion: string;
};

export const createHandlers = ({
  apiUrl,
  shopifyApiVersion,
  shopifyDomain,
}: MockHandlerOptions) => {
  const normalizedApiUrl = apiUrl.replace(/\/+$/, "");
  const webappUrl = `${normalizedApiUrl}/webapp`;
  const shopifyOrigin = getStorefrontOrigin(shopifyDomain);
  const storefrontEndpoint = getStorefrontEndpoint(shopifyDomain, shopifyApiVersion);

  return [
    ...createAuthHandlers(webappUrl),
    ...createProfileHandlers(webappUrl),
    ...createCareplanHandlers(webappUrl),
    ...createSubscriptionHandlers(webappUrl),
    ...createMessageHandlers(webappUrl),
    ...createSurveyHandlers(webappUrl),
    ...createProgressHandlers(webappUrl),
    ...createProductHandlers(webappUrl),
    ...createProfilingHandlers({ webappUrl, shopifyOrigin }),
    ...createPostPurchaseHandlers({ apiUrl: normalizedApiUrl, shopifyOrigin }),
    ...createShopifyHandlers({ shopifyOrigin, storefrontEndpoint }),
    ...createAnalyticsHandlers(),
    ...createUnhandledHandlers({ apiUrl: normalizedApiUrl, storefrontEndpoint }),
  ];
};
